/* eslint-disable no-console */
import * as React from "react";
import {
  Container,
  Typography,
  Button,
  makeStyles,
  createStyles,
  Theme,
  Switch,
  InputAdornment,
} from "@material-ui/core";
import BaseFilter from "../../core/models/BaseFilter";
import MaterialSelect from "../MaterialSelect";
import SearchIcon from "@material-ui/icons/Search";
import clsx from "clsx";
import SimpleTextField from "../SimpleTextField";
import MaterialDatePickerComponent from "../MaterialDatePickerComponent";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "backgroundColor": theme.customPaper.background.cardBackgroundLight,
      "padding": theme.spacing(1.5, 2),
      "marginBottom": theme.spacing(2),
      "display": "flex",
      "alignItems": "center",

      "& .flex-1": {
        flex: 1,
        columnGap: theme.spacing(2),
      },

      // TODO - passar para theme
      "& .border-right": {
        borderRight: "1px dotted #707070",
      },

      "& .border-left": {
        borderLeft: "1px dotted #707070",
      },
    },

    orderFilter: {
      paddingRight: theme.spacing(1),
    },

    switchFilter: {
      paddingRight: theme.spacing(3),
      marginLeft: -theme.spacing(2),
    },

    switchTypography: {
      marginLeft: -theme.spacing(2),
    },

    searchFilter: {
      flex: 0.45,
    },

    searchButton: {
      flex: 0.25,
      marginRight: theme.spacing(1),
    },

    flexBox: {
      display: "flex",
      alignItems: "center",
      columnGap: theme.spacing(2),
    },

    button: {
      minWidth: 200,
      background: theme.palette.type == "dark" ? theme.palette.background.default : theme.palette.common.white,
      marginLeft: theme.spacing(2),
    },
  })
);

export type AdminPageFilterComponentProps = {
  filters: BaseFilter[];
  handleClickCreateGroup?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

function AdminPageFilterComponent(props: AdminPageFilterComponentProps) {
  const { filters, handleClickCreateGroup } = props;

  const [input, setInput] = React.useState<string>();

  const classes = useStyles();

  return (
    <Container className={classes.root} maxWidth="xl">
      {/* Pesquisa por texto */}
      <div className={classes.searchFilter}>
        <SimpleTextField
          value={input ?? ""}
          onChange={(e) => setInput(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={classes.searchButton}>
        {filters
          .filter((cond) => {
            return cond.id === "buscar";
          })
          .map((filter) => (
            <Button
              key={filter.id}
              onClick={(e) => (filter.handleChange ? filter.handleChange(e, input) : () => {})}
              name="Buscar"
              variant="outlined"
            >
              Buscar
            </Button>
          ))}
      </div>
      <div className={clsx(classes.flexBox, "flex-1")}>
        {/* Filtro Ordenar */}
        <div className={clsx(classes.flexBox, "border-right", classes.orderFilter)}>
          <Typography>Ordenar: </Typography>

          {filters
            .filter((cond) => {
              return cond.id === "ordenar";
            })
            .map((filter) => (
              <MaterialSelect key={filter.id} filter={filter} />
            ))}
        </div>
        {/* Filtros Organização e Diretoria */}
        <div className={clsx(classes.flexBox, "border-right")}>
          <Typography>Filtrar: </Typography>
          {filters
            .filter((cond) => {
              return cond.id === "organizacao" || cond.id === "diretoria";
            })
            .map((filter) => (
              <MaterialSelect key={filter.id} filter={filter} />
            ))}
        </div>

        <div className={clsx(classes.flexBox, "border-right", classes.switchFilter)}>
          {filters
            .filter((cond) => {
              return cond.id === "exp-groups";
            })
            .map((filter) => (
              <>
                <Switch
                  key={filter.id}
                  onChange={(e) => (filter.handleChange ? filter.handleChange(e) : () => {})}
                  checked={Boolean(filter.value)}
                  name={filter.label}
                  color="primary"
                />

                <Typography className={classes.switchTypography}>{filter.label}</Typography>
              </>
            ))}
        </div>

        <div className={clsx(classes.flexBox, "border-right", classes.switchFilter)}>
          {filters
            .filter((cond) => {
              return cond.id === "meus-grupos";
            })
            .map((filter) => (
              <>
                <Switch
                  key={filter.id}
                  onChange={(e) => (filter.handleChange ? filter.handleChange(e) : () => {})}
                  checked={Boolean(filter.value)}
                  name={filter.label}
                  color="primary"
                />

                <Typography className={classes.switchTypography}>{filter.label}</Typography>
              </>
            ))}
        </div>
      </div>

      <div>
        <Button className={classes.button} onClick={handleClickCreateGroup}>
          Criar Grupo
        </Button>
      </div>
    </Container>
  );
}

export default AdminPageFilterComponent;
